import { render, staticRenderFns } from "./barcodeSaleProfit.vue?vue&type=template&id=5e2c638f&scoped=true&"
import script from "./barcodeSaleProfit.vue?vue&type=script&lang=js&"
export * from "./barcodeSaleProfit.vue?vue&type=script&lang=js&"
import style0 from "./barcodeSaleProfit.vue?vue&type=style&index=0&id=5e2c638f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c638f",
  null
  
)

export default component.exports